import { Link } from "react-router-dom";
import { siteMeta, siteStats, tickerItems } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative">
      <div className="relative flex min-h-[560px] w-full flex-col justify-center overflow-hidden md:min-h-[680px]">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20theater%20stage%20with%20deep%20crimson%20velvet%20curtains%20and%20warm%20golden%20spotlight%20beams%20cutting%20through%20floating%20dust%2C%20dramatic%20mysterious%20atmosphere%2C%20wide%20editorial%20composition%20with%20dark%20vignette%20edges%20for%20text%20overlay%2C%20rich%20shadows%2C%20high%20detail%2C%20no%20people&width=1800&height=1100&seq=guada-hero-01&orientation=landscape"
          alt="暗示名利场与聚光灯的抽象舞台背景"
          title="诱惑吃瓜 - 实锤证据 反转辟谣 真相全复盘"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-foreground-950/70 to-primary-950/90"></div>

        <div className="relative z-10 w-full px-4 pb-16 pt-28 md:px-8 md:pb-20 md:pt-36 lg:px-12">
          <div className="mx-auto max-w-5xl text-center">
            <p className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs text-accent-300 backdrop-blur-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-radar-line" aria-hidden="true"></i>
              </span>
              今日已更新 6 条事件复盘 · 新增 4 组核查材料
            </p>

            <h2 className="mt-6 font-heading text-3xl font-bold leading-tight tracking-tight text-background-50 sm:text-4xl md:text-6xl">
              把每个瓜的来龙去脉
              <span className="mt-2 block text-accent-400">捋得明明白白</span>
            </h2>

            <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              {siteMeta.description}
            </p>

            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
              <Link
                to="/topics"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                </span>
                查看今日热榜
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-book-open-line" aria-hidden="true"></i>
                </span>
                了解复盘方法
              </Link>
            </div>

            <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-x-4 gap-y-6 border-t border-background-50/20 pt-8 lg:grid-cols-4">
              {siteStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <dt className="sr-only">{stat.label}</dt>
                  <dd>
                    <span className="block font-heading text-2xl font-bold text-background-50 md:text-3xl">
                      {stat.value}
                    </span>
                    <span className="mt-1 block text-xs text-background-300">
                      {stat.label}
                    </span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      <div className="flex w-full items-center gap-4 overflow-hidden bg-accent-500 px-4 py-2.5 md:px-8">
        <span className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs font-bold tracking-wide text-foreground-950">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-live-line" aria-hidden="true"></i>
          </span>
          实时播报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="guada-ticker-track flex w-max items-center gap-10">
            {[...tickerItems, ...tickerItems].map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="whitespace-nowrap text-xs text-foreground-900"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}